module.exports = __webpack_public_path__ + "img/white_king.33ff5599.png";